import type { Arm, NavImpactSurfaces } from '../arms';

import { spec as v1DeltaChips } from './v1_delta_chips';

export type ArmSpec = () => Partial<NavImpactSurfaces>;

export const ARMS: Partial<Record<Arm, ArmSpec>> = {
  v1_delta_chips: v1DeltaChips,
};
